import { InjectionToken } from '@angular/core';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const SLIDE_IN_DATA = new InjectionToken<string>('SLIDE_IN_DATA');
